<template>
    <nav class="layout-breadcrumb tw:flex tw:justify-between">
        <ol class="tw:w-4/5">
            <li v-if="!isHome">
                <router-link :to="home.to" style="color: inherit">
                    <i :class="home.icon" />
                </router-link>
            </li>
            <li v-if="!isHome && breadcrumbItems.length > 0" class="layout-breadcrumb-chevron">/</li>
            <template v-if="!isHome">
                <template v-for="(crumb, i) in breadcrumbItems" :key="i">
                    <li class="tw:normal-case tw:min-w-0 tw:flex tw:items-center">
                        <router-link
                            v-if="crumb.to && i !== breadcrumbItems.length - 1"
                            :to="crumb.to"
                            class="tw:block tw:min-w-0 tw:max-w-[10rem] tw:md:max-w-[24rem] tw:truncate"
                        >
                            {{ crumb.text }}
                        </router-link>
                        <span
                            v-else
                            class="tw:block tw:min-w-0 tw:max-w-[10rem] tw:md:max-w-[24rem] tw:truncate"
                        >{{ crumb.text }}</span>
                    </li>
                    <li v-if="i !== breadcrumbItems.length - 1" class="layout-breadcrumb-chevron">/</li>
                </template>
            </template>
        </ol>
        <div class="layout-breadcrumb-actions tw:flex tw:min-w-0 tw:flex-1 tw:items-center tw:justify-end tw:gap-2">
            <portal-target name="breadcrumb-activity-nav" />
            <portal-target name="breadcrumb-actions" />
        </div>
    </nav>
    <Divider />
</template>

<script setup>
import { computed, ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';

const route = useRoute();
const store = useStore();
const home = { icon: 'pi pi-home', to: '/' };
const fallbackBreadcrumbs = ref([]);

const isHome = computed(() => route.path === '/');

const storeBreadcrumbs = computed(() => store.state.Breadcrumbs.breadcrumbs);

const breadcrumbItems = computed(() => {
    if (storeBreadcrumbs.value && storeBreadcrumbs.value.length > 0) {
        return storeBreadcrumbs.value;
    }
    return fallbackBreadcrumbs.value;
});

function setFallbackBreadcrumbs() {
    if (route.meta.breadcrumb) {
        fallbackBreadcrumbs.value = route.meta.breadcrumb.map(text => ({ text }));
        return;
    }

    fallbackBreadcrumbs.value = route.fullPath
        .split('?')[0]
        .split('/')
        .filter(item => item !== '')
        .filter(item => isNaN(Number(item)))
        .map(item => {
            const withSpaces = item.replace(/-/g, ' ');
            return { text: withSpaces.charAt(0).toUpperCase() + withSpaces.slice(1) };
        });
}

watch(
    route,
    () => {
        setFallbackBreadcrumbs();
    },
    { immediate: true }
);
</script>
